export const useAlgoliaMappedProducts = (result: any) => {
  return computed(() =>
    !result?.value ? [] : getAlgoliaMappedProducts(result.value.results)
  )
}
